import braze from '~/services/braze.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  legacyId: string;
  productName: string;
};

class RemoveNotificationEvent extends UserEvent<EventData> {
  sendToBraze() {
    braze.logReminderEvent({
      itemId: this.data.legacyId,
      reminded: false
    });
  }
}

export default RemoveNotificationEvent;
